import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { Observable } from 'rxjs';
import { AuthService } from '@core/service/auth.service';


@Injectable()
export class EndpointService {

  // ADMIN
  public getProfileToken: any = 'api/user-profile/token';

  // LOG
  public verifyAccess: any = "gateway/etask/api/etask/verification/verify/access?taskId=648489";

  //REPORT


}
